import { render, staticRenderFns } from "./FpMarkdown.vue?vue&type=template&id=a8bc17b4&scoped=true"
import script from "./FpMarkdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./FpMarkdown.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FpMarkdown.vue?vue&type=style&index=0&id=a8bc17b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_underscore@1.13.6_vue-template-compiler@2.7.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bc17b4",
  null
  
)

export default component.exports